import httpCommon from "./http-common";

// TypeScript interfaces
export interface BankAccount {
  id: number;
  businessId: number;
  accountName: string;
  accountNumber: string;
  bankName: string;
  branchName: string;
  branchCode: string;
  routingNumber?: string;
  swiftCode?: string;
  accountType: string;
  currency: string;
  country: string;
  isPrimary: boolean;
  description?: string;
  dateCreated: string;
}

// Get all bank accounts for a business
const getBusinessBankAccounts = (businessPublicId: string) => {
  return httpCommon.get(`/v1/get/businessBankAccounts/${businessPublicId}`);
};

// Get a single bank account
const getBankAccount = (id: number) => {
  return httpCommon.get(`/v1/get/businessBankAccount/${id}`);
};

// Create a new bank account
const createBankAccount = (businessPublicId: string, data: any) => {
  return httpCommon.post(`/v1/add/businessBankAccount/${businessPublicId}`, data);
};

// Update an existing bank account
const updateBankAccount = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/businessBankAccount/${id}`, data);
};

// Delete a bank account
const deleteBankAccount = (id: number) => {
  return httpCommon.delete(`/v1/delete/businessBankAccount/${id}`);
};

const BankAccountsService = {
  getBusinessBankAccounts,
  getBankAccount,
  createBankAccount,
  updateBankAccount,
  deleteBankAccount,
};

export default BankAccountsService; 